// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as PnMHelper$PorterinFeature from "../../../domain/helper/PnMHelper.mjs";
import * as PnMStoreEn$PorterinFeature from "../../../domain/store/PnMStoreEn.mjs";
import * as PnmDropDownListCmp$PorterinFeature from "./PnmDropDownListCmp.mjs";
import * as PnMHouseSizeDropdownModuleScss from "../../styles/PnMHouseSizeDropdown.module.scss";

var styles = PnMHouseSizeDropdownModuleScss;

function PnMHouseSizeDropdownCmp(Props) {
  var props = Props.props;
  var match = React.useState(function () {
        return false;
      });
  var setIsOpen = match[1];
  var isOpen = match[0];
  var timeOutRef = React.useRef(null);
  var $$clearTimeout$1 = function (param) {
    var timeoutId = timeOutRef.current;
    if (!(timeoutId == null)) {
      clearTimeout(timeoutId);
      return ;
    }
    
  };
  var handleItemClick = function (value) {
    Curry._1(props.selection.on_item_selection, value);
    Curry._1(setIsOpen, (function (param) {
            return false;
          }));
    $$clearTimeout$1(undefined);
  };
  React.useEffect((function () {
          return (function (param) {
                    $$clearTimeout$1(undefined);
                  });
        }), []);
  var tmp;
  if (isOpen) {
    var init = props.selection;
    tmp = React.createElement(PnmDropDownListCmp$PorterinFeature.make, {
          props: {
            list: props.list,
            selection: {
              on_item_selection: handleItemClick,
              selected_item: init.selected_item
            },
            error: props.error
          },
          styles: styles
        });
  } else {
    tmp = null;
  }
  var msg = props.error;
  return React.createElement("div", {
              className: styles["dropdown-container"]
            }, React.createElement("div", {
                  className: styles["dropdown-input-wrapper"],
                  onClick: (function (param) {
                      Curry._1(setIsOpen, (function (prev) {
                              return !prev;
                            }));
                    })
                }, React.createElement("input", {
                      className: styles["dropdown-input"],
                      placeholder: PnMStoreEn$PorterinFeature.houseSizePlaceholder,
                      readOnly: true,
                      type: "text",
                      value: Belt_Option.getWithDefault(props.selection.selected_item, ""),
                      onBlur: (function (param) {
                          $$clearTimeout$1(undefined);
                          timeOutRef.current = setTimeout((function (param) {
                                  Curry._1(setIsOpen, (function (param) {
                                          return false;
                                        }));
                                }), PnMStoreEn$PorterinFeature.dropdownListTimeDelay);
                        })
                    }), React.createElement("span", {
                      className: PnMHelper$PorterinFeature.accordionStyles(isOpen, styles)
                    })), tmp, msg !== undefined ? React.createElement("div", {
                    className: styles["error-container"]
                  }, msg) : null);
}

var make = PnMHouseSizeDropdownCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
